// extracted by mini-css-extract-plugin
export default {"Button":"DarkButton_Button__oLRYs","FullWidth":"DarkButton_FullWidth__qi1Qe","ButtonIcon":"DarkButton_ButtonIcon__Ca3qx"};